import { MDSDropdown } from '@marqvision/mds-v2';
import { usePlatformOptions } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const PlatformsFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const platforms = usePlatformOptions();

  return (
    <MDSDropdown
      label="Platforms"
      value={platforms.selected}
      list={platforms.list}
      isDisabled={platforms.disabled}
      isLoading={platforms.isFetching}
      onChange={(value: any) => platforms.select(value)}
      modules={[
        'search',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
